import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AlloyService } from '../services/alloy.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const alloyService = inject(AlloyService);

  // if the token has been stored in sessionStorage...
  const token = localStorage.getItem('access_token');
  const tmxSessionId = alloyService.getTmxSessionId();


  /**
   * A list of domains to set custom headers and Bearer token, the list must be exclude all domains related to ping identity.
   * If you need to set a custo domain please add into the environment file. 
   */
  const allowedDomains = [environment.apiURL];

  // If the domain exist int the list will add the custom headers
  const isIntheList = allowedDomains.some(domain => req.url.startsWith(domain));

  // const ssoToken = 'haJef6DTMWoVrH8M0w3pcowSVEI.*AAJTSQACMDIAAlNLABxaZHk3L3lQSVAvVXg3K2NZTVo0eVJGRzJONUk9AAR0eXBlAANDVFMAAlMxAAIwMQ..*';

  const headersConfig: Record<string, string> = {
    'x-auth-vendor': 'forgeRock',
    // 'cookie-set': ssoToken
  };

  if (token) {
    headersConfig['Authorization'] = `Bearer ${token}`;
    // headersConfig['xyzcookie'] = `bc96a1a5a456d67=bUGdcXRAMSeY8XFlrCmIQYRsxWo.*AAJTSQACMDIAAlNLABx6OFpGZVh5UkQvR3dBSEYzVjRKUUs0MmJaTzA9AAR0eXBlAANDVFMAAlMxAAIwMQ..*`;
  }

  if (tmxSessionId) {
    headersConfig['x-tmx-session-id'] = tmxSessionId;
  }

  // If we want to validate the SSO Token we will include the cookie
  // const callingToVerifySSOToken = req.url.includes('/profile/validate');
  // if(callingToVerifySSOToken) {
  //   headersConfig['a1d213d00e6ea91'] = ssoToken;
  // }

  const requestBody = req.body as Record<string, any> | null;
  const isPostProfileRequest = req.method === 'POST' && req.url.includes('/profile/');

  const journeyStartEndpoints = [
    '/profile/update-password',
    '/profile/update-firstname-lastname',
    '/profile/update-profile',
    '/profile/mfa-registration',
    '/profile/add-MFA',
    '/profile/password-less',
    '/profile/add-passkey',
  ];

  const isJourneyStartEndpoint = journeyStartEndpoints.some((path) => req.url.includes(path));
  const isJourneyContinuationPayload = Boolean(requestBody?.['authId'])
    || Array.isArray(requestBody?.['callbacks'])
    || typeof requestBody?.['stage'] === 'string';

  const isJourneyRequest = isPostProfileRequest && (isJourneyStartEndpoint || isJourneyContinuationPayload);

  const isInitialJourneyStep = isJourneyRequest && !!requestBody && !requestBody['authId'];
  const requestedUserName = typeof requestBody?.['userName'] === 'string' ? requestBody['userName'].trim() : '';

  if (isInitialJourneyStep && requestedUserName) {
    headersConfig['X-OpenAM-Username'] = requestedUserName;
  }

  if (isIntheList) {
    const cloned = req.clone({
      withCredentials: true,
      setHeaders: headersConfig
    });
    return next(cloned);
  }
  return next(req);
};
